
import React from 'react';
import { Route, Routes } from 'react-router-dom';
import BookingOrders from '../app/protected/Host/BookingOrders/BookingOrders';
import HostPolicy from '../app/protected/Host/HostPolicy/HostPolicy';
import HostPropertyDetails from '../app/protected/Host/PropertyDetails/PropertyDetails';
import PgMarketplace from '../components/PgMarketplace/PgMarketplace';

const HostRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="booking-orders" element={<BookingOrders />} />
      <Route path="policies" element={<HostPolicy />} />
      <Route path="property/:property_id" element={<HostPropertyDetails />} />
      <Route path="pg-marketplace" element={<PgMarketplace />} />
    </Routes>
  );
};

export default HostRoutes;
